import React from 'react'
import { Box } from 'grommet'
import styled, { css } from 'styled-components'
import { useHideInput } from '../../contextHook/hideInput'

const AppearStyle = css`
  opacity: 1;
  left: 0rem;
`

const FloatingBoxContainer = styled(Box)`
  position: absolute;
  z-index: 10;
  left: -47rem;
  top: 2rem;
  opacity: 0;
  transition: left 0.5s, opacity 0.5s;
  justify-content: center;
  max-width: 39rem;
  align-items: flex-start;
  margin: 0 1.5rem;
  min-width: 23rem;
  ${props => props.shouldAppear && AppearStyle}
`

const FloatingBox = ({ fullScreenActive, children }) => {
  const { hiding } = useHideInput()
  return (
    <FloatingBoxContainer shouldAppear={fullScreenActive || hiding} gap="1rem">
      {children}
    </FloatingBoxContainer>
  )
}

export default FloatingBox
